<template>
  <div id="dashboard-payouts" class="overflow-section px-2">
      <v-expansion-panel
        v-model="panel"
        expand>
        <v-expansion-panel-content readonly>
          <div id="table-two">
          <v-progress-linear
            v-if="processBar"
            :indeterminate="processBar"
            color="green"
            height="3"
          ></v-progress-linear>
          <transition name="fade">
            <div class="loading" v-if="loadingSpin">
              <span class="fa fa-spinner fa-spin"></span> Loading
            </div>
          </transition>
          <v-data-table
            :headers="expandedheaders"
            :items="payout_wrt_paydates"
            hide-actions
            class="testiing" id="infinite-list"
            >
            
            <template slot="items" slot-scope="props">
              <tr>
                <td style="text-align: left; height: 25px;">
                  <span class="font-size">{{ props.item.contract_MID }}</span>
                </td>
                <td style="text-align: left; height: 25px;">
                  <span class="font-size">{{ props.item.syndication_company_name }}</span>
                </td>
                <td style="text-align: left; height: 25px;">
                  <span class="font-size">{{ props.item.total_gross_amount | currency }}</span>
                </td>
                <td style="text-align: left; height: 25px;">
                  <span class="font-size">{{ props.item.total_mgt_fee | currency }}</span>
                </td>
                <td style="text-align: left; height: 25px;">
                  <span class="font-size">{{ props.item.total_net_pay | currency }}</span>
                </td>
                <td style="text-align: left; height: 25px;">
                  <span class="font-size">{{ props.item.numbers_of_transactions }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
  </div>
</template>

<script>
import {URL, config} from '../../env';
import axios from "axios";
export default {
  props: {
    selectedItem: {
      type: Object,
      default: () => {},
      required: true
    },
  },
    
  components: {
  },
  mounted(){
    this.getPayoutsWRTPayDates(this.selectedItem)
    this.listen()
  },
  methods:{
    activateCurrentTab(){
      var header = document.getElementById("myDIV");
      var btns = header.getElementsByClassName("btnn_act");
      for (var i = 0; i < btns.length; i++) {
        btns[i].classList.remove("active");
        btns[i].addEventListener("click", function() {
          this.className += " active";
        });
      }
    },
    async getPayoutsWRTPayDates(item){
      this.payout_wrt_paydates = []
      this.status = false
      this.activateCurrentTab()
      let app = this
      app.processBar = true
      this.payoutsdata = []
      
      this.payoutsdata.push(item)
      this.tableData = Object.assign(this.tableData , {
        syndication_id: item.syndication_id,
        pay_date: item.pay_date,
        page: 1
      })
      await axios.get(`${URL}/api/payouts/get_payouts_wrt_paydate`,{
        params: this.tableData
      }).then(res=>{
        app.processBar = false
        this.payout_wrt_paydates = res.data.data
        this.payout_wrt_paydates_total = res.data.total
        this.status = true
      }).catch(err=>{
        app.processBar = false
      })
    },

    listen(){
      const listElm = document.querySelector('#infinite-list');
      listElm.addEventListener('scroll', e => {
        if(listElm.scrollTop + listElm.clientHeight + 5 >= listElm.scrollHeight && this.status) {
          this.loadMore();
        }
      });
    },

    async loadMore(){
      if(this.payout_wrt_paydates.length < this.payout_wrt_paydates_total){
        this.loadingSpin = true
        this.tableData.page = this.tableData.page + 1
        await axios.get(`${URL}/api/payouts/get_payouts_wrt_paydate`,{
          params: this.tableData 
        }).then(res=>{
          let latest_data = _.concat(this.payout_wrt_paydates , res.data.data)
          this.payout_wrt_paydates = latest_data
          this.loadingSpin = false
        })
      }
    },

  },
  data() {
    return {
      status: true,
      payout_wrt_paydates_total: 0,
      tableData:{
        page:1,
        length: 25
      },
      tableDataPayDates:{
        page:1,
        length: 25
      },
      loadingSpin:false,
      processBar: false,
      processBarPayDates:false,
      payout_wrt_paydates:[],
      payout_pay_paydates: {
        data: []
      },
      panel: [true],
      expandedheaders: [
        {
          text: 'MID',
          align: 'left',
          value: 'mid'
        },
        { text: 'Company Name', value: 'companyName' },
        { text: 'Gross Amount', value: 'dealGrossAmount' },
        { text: 'Mgt Fee', value: 'dealMgtFee' },
        { text: 'Net Pay', value: 'dealNetPay' },
        { text: 'No. of Transactions', value: 'noOfTransactions' },
      ],
      payoutsdata: []
    };
  },
  
};
</script>

<style scoped>
.vue-tabs .nav-pills > li + li{
  margin-left:0px !important;
}
.container-width {
  max-width: 100% !important;
}

.nav-item {
  text-align: center;
  background-color:#f1f2f5;
}
.nav-item button {
  padding: 2px;
  font-size: 11px;
  line-height: 1.3;
  font-weight: 400;
  width: 100%;
  margin: 0;
}

.overflow-section {
  /*overflow-y: scroll;*/
  /* overflow-x: hidden; */
  overflow: hidden;
  height: 650px;
  max-height: 650px;
  border: 1px solid #eeeeee;
}

.side-list {
  font-size: 13px !important;
  height: 100%;
}

.th-style {
  text-align: left; 
  color: #000;
  font-weight: 900;
}

/*scroll bar*/
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.vue-tabs .nav-tabs {
    border:1px solid #eee;
}
</style>

<style scoped>
.theme--light.v-text-field--outline>.v-input__control>.v-input__slot{
  border: 1px solid rgba(68, 68, 68, 0.4) !important;
}

/* #dashboard-payouts table.v-table tbody td {
    padding: 0px !important;
} */

#dashboard-payouts tr.v-datatable__progress {
    display: none;
}

#dashboard-payouts .theme--light.v-table thead tr:first-child {
    height: 25px !important;
}

#dashboard-payouts .v-expansion-panel__header {
    padding: 0px;
    cursor: default;
}

#dashboard-payouts .v-expansion-panel__header__icon {
    display: none;
}

#dashboard-payouts .v-expansion-panel {
    box-shadow: none;
}

#payouts-left .v-navigation-drawer__border {
    display: none !important;

  
}


#table-two table.v-table thead th {
    font-weight: 900 !important;
}



/* infinite scroll */
.testiing {
  overflow: auto;
  height: 85vh; 
}

/* infinite scroll */
.testiing-paydates {
  overflow: auto;
  height: 65vh; 
}

.loading {
  text-align: center;
  position: absolute;
  color: rgb(209, 240, 238);
  z-index: 9;
  padding: 18px;
  font-size: 30px;
  border-radius: 10px;
  left: calc(45% - 45px);
  top: calc(45% - 18px);
  background-color: green;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

</style>